package com.yendo.mx.utils

import kotlinx.datetime.Instant
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlin.math.roundToInt

fun redondear(valor: Double): Double {
    return (valor * 100.0).roundToInt() / 100.0
}

fun formatPrecio(precio: Double): String {
    return formatDecimal(precio, 2)
}

fun formatDecimal(valor: Double, decimales: Int): String {
    val partes = valor.toString().split(".")
    val entero = partes[0]
    val decimal = if (partes.size > 1) partes[1] else ""
    
    return if (decimales <= 0) {
        entero
    } else {
        "$entero.${decimal.padEnd(decimales, '0').take(decimales)}"
    }
}

fun formatFecha(epoch: Long): String {
    return try {
        val instant = Instant.fromEpochMilliseconds(epoch)
        val dateTime = instant.toLocalDateTime(TimeZone.currentSystemDefault())
        "${dateTime.dayOfMonth} ${dateTime.month.name.take(3)} • ${dateTime.hour}:${dateTime.minute.toString().padStart(2, '0')}"
    } catch (e: Exception) { "" }
}

fun formatoHora(millis: Long): String {
    val instant = Instant.fromEpochMilliseconds(millis)
    val local = instant.toLocalDateTime(TimeZone.currentSystemDefault())
    val h = local.hour.toString().padStart(2, '0')
    val m = local.minute.toString().padStart(2, '0')
    return "$h:$m"
}

fun formatoFechaHora(millis: Long): String {
    val instant = Instant.fromEpochMilliseconds(millis)
    val local = instant.toLocalDateTime(TimeZone.currentSystemDefault())
    val d = local.dayOfMonth.toString().padStart(2, '0')
    val mo = local.monthNumber.toString().padStart(2, '0')
    val h = local.hour.toString().padStart(2, '0')
    val m = local.minute.toString().padStart(2, '0')
    return "$d/$mo • $h:$m"
}

fun formatEstadoHuman(estado: String): String {
    if (estado.isBlank()) return "Desconocido"
    val e = estado.trim().uppercase()
    return when (e) {
        "SOLICITUD" -> "Solicitud Recibida"
        "PENDIENTE_PAGO" -> "Pendiente de Pago"
        "ESPERANDO_COMPROBANTE" -> "Esperando Comprobante"
        "REVISANDO_COMPROBANTE" -> "Revisando Comprobante"
        "REINTENTAR_PAGO" -> "Reintentar Pago"
        "VALIDACION", "VALIDACION_CLIENTE" -> "En Validación"
        "ARMANDO_PEDIDO" -> "Armando Pedido"
        "PROCESANDO_AJUSTE" -> "Procesando Ajuste"
        "PREPARANDO" -> "En Preparación"
        "LISTO" -> "Listo"
        "LISTO_RECOGER" -> "Listo para Recoger"
        "BUSCANDO_REPARTIDOR" -> "Buscando Repartidor"
        "ACEPTADO_POR_REPARTIDOR" -> "Repartidor Asignado"
        "RECOLECTANDO" -> "Repartidor en Local"
        "EN_CAMINO" -> "En Camino"
        "EN_PUERTA" -> "Repartidor en Domicilio"
        "ENTREGADO", "CONCLUIDO" -> "Entregado"
        "CANCELADO", "CANCELADO_SISTEMA" -> "Cancelado"
        else -> estado.replace("_", " ").lowercase().split(" ").joinToString(" ") { word ->
            word.replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() }
        }
    }
}
